import * as React from 'react';
import '../../Css/Global/Global.css';

import {Grid} from "@mui/material";


import TableIcmsNcm from './TableIcmsNcm';
import DonutChartWithTable from '../../Components/DonutChartWithTable';
import DonutChartPorNcm from './DonutChartPorNcm';

import { IcmsPorNcm, DebitoIcmsNcmGrafico } from './types';
import SpedStatusHandler from '../Dashboard/SpedStatusHandler';
import { formatHorizontalBarLabel } from '../../Components/DrillDown/formatters';
import InfoCard from '../Dashboard/InfoCard';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
  

const AnalisesNcm: React.FC = () => {

    const [loading, setLoading] = React.useState(true);

    const [spedFiscalIdSelecionado, setSpedFiscalIdSelecionado] = React.useState<number | null>(null);

    const [dadosDebitoNcm, setDadosDebitoIcms] = React.useState<{ id: string; value: number }[]>([]);
    const [dadosCreditoNcm, setDadosCreditoIcms] = React.useState<{ id: string; value: number }[]>([]);

    const [dadosNcmIcms, setDadosNcmIcms] = React.useState<IcmsPorNcm[]>([]);
    const [dadosNcmIcmsSt, setDadosNcmIcmsSt] = React.useState<IcmsPorNcm[]>([]);

    React.useEffect(() => {
      if (Number(spedFiscalIdSelecionado) > 0){
        const fetchData = async () => {
          try {
            setLoading(true);
            const response = await fetch(process.env.REACT_APP_API_URL+'icms-por-ncm/'+spedFiscalIdSelecionado);
            const data = await response.json();
      
            // Aqui você pode validar se os dados têm a estrutura esperada
            if (Array.isArray(data)) {
              setDadosNcmIcms(data);
            } else {
              console.error('Dados de produtos inválidos:', data);
            }

            const responseSt = await fetch(process.env.REACT_APP_API_URL+'icms-st-por-ncm/'+spedFiscalIdSelecionado);
            const dataSt = await responseSt.json();
      
            // Aqui você pode validar se os dados têm a estrutura esperada
            if (Array.isArray(dataSt)) {
              setDadosNcmIcmsSt(dataSt);
            } else {
              console.error('Dados de produtos inválidos:', dataSt);
            }

            const responseGrafico1 = await fetch(process.env.REACT_APP_API_URL+'top-ncm-debito-icms/'+spedFiscalIdSelecionado);
            const data1: DebitoIcmsNcmGrafico[] = await responseGrafico1.json();

            if (Array.isArray(data1)) {
              // transforma os dados no formato esperado pelo gráfico de barras horizontais
              const formatado = data1.map(item => {
                const fullDescription = `${item.ncm} - ${item.descricao ?? 'Sem descrição'}`;
                return {
                  id: fullDescription,
                  value: item.total,
                };
              });
      
              setDadosDebitoIcms(formatado);
            } else {
              console.error('Dados de ncms inválidos:', data1);
            }

            const responseGrafico2 = await fetch(process.env.REACT_APP_API_URL+'top-ncm-credito-icms/'+spedFiscalIdSelecionado);
            const data2: DebitoIcmsNcmGrafico[] = await responseGrafico2.json();

            if (Array.isArray(data2)) {
              // transforma os dados no formato esperado pelo gráfico de barras horizontais
              const formatado2 = data2.map(item => {
                const fullDescription = `${item.ncm} - ${item.descricao ?? 'Sem descrição'}`;
                return {
                  id: fullDescription,
                  value: item.total,
                };
              });
              
              setDadosCreditoIcms(formatado2);
            } else {
              console.error('Dados de ncms inválidos:', data2);
            }

          } catch (e) {
            console.error('Erro ao carregar dados de produtos ICMS', e);
          } finally {
            setLoading(false);
          }
        };
      
        fetchData();
    }
      }, [spedFiscalIdSelecionado]);


    return (
        <>
            <Grid container spacing={0.5}>

              <SpedStatusHandler
                  onSpedFiscalIdChange={(id) => {
                      setSpedFiscalIdSelecionado(id);
                  }}
              />

              <InfoCard title="Análise de ICMS por NCM" icon={<AddShoppingCartIcon />} iconColor="info" size={12} />

              <Grid item xs={12} md={6} lg={6}>
                <DonutChartPorNcm
                  data={dadosDebitoNcm}
                  title="TOP 10 DÉBITOS DE ICMS POR NCM"
                  loading={loading}
                  spedFiscalId={spedFiscalIdSelecionado || undefined}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <DonutChartPorNcm
                  data={dadosCreditoNcm}
                  title="TOP 10 CRÉDITOS DE ICMS POR NCM"
                  loading={loading}
                  spedFiscalId={spedFiscalIdSelecionado || undefined}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                  <TableIcmsNcm data={dadosNcmIcms} title="Detalhamento de Créditos e Débitos por NCM - ICMS" loading={loading} />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                  <TableIcmsNcm data={dadosNcmIcmsSt} title="Detalhamento de Créditos e Débitos por NCM - ICMS ST" loading={loading} />
              </Grid>
            </Grid>              
        </>
      );
      
}


export default AnalisesNcm;

